import SymptomTracker from './symptomTracker';

export default SymptomTracker;
